import React from 'react';

const Experience = () => {
  return (
    <section id="experience" className="py-16 bg-white text-center">
      <h2 className="text-3xl md:text-4xl font-bold mb-12 text-indigo-600">
        Experience 💼
      </h2>

      <div className="max-w-4xl mx-auto space-y-8 text-left px-4">

        {/* Digiworld Solution */}
        <div className="bg-gray-100 p-6 rounded-xl shadow hover:shadow-lg transition">
          <div className="flex items-center justify-between mb-2">
            <h3 className="text-xl font-semibold text-indigo-700">
              💻 Digiworld Solution
            </h3>
            <span className="text-sm text-gray-500">
              Nov 2024 – Present
            </span>
          </div>
          <p className="text-sm text-gray-600 mb-2">
            Java Full Stack Developer
          </p>
          <ul className="list-disc list-inside text-gray-700 space-y-1">
            <li>Developed full-stack applications using Spring Boot, PostgreSQL & React.</li>
            <li>Implemented JWT authentication and dynamic UI using Tailwind CSS.</li>
          </ul>
        </div>

        {/* Krezybee */}
        <div className="bg-gray-100 p-6 rounded-xl shadow hover:shadow-lg transition">
          <div className="flex items-center justify-between mb-2">
            <h3 className="text-xl font-semibold text-indigo-700">
              KrazyBee Services Limited
            </h3>
            <span className="text-sm text-gray-500">
              Sep 2023 – Nov 2024
            </span>
          </div>
          <p className="text-sm text-gray-600 mb-2">
            Backend Developer
          </p>
          <ul className="list-disc list-inside text-gray-700 space-y-1">
            <li>Built scalable APIs using Java and optimized backend performance.</li>
            <li>Worked on cloud deployment, database design & microservices.</li>
          </ul>
        </div>

        {/* Tata Elxsi */}
        <div className="bg-gray-100 p-6 rounded-xl shadow hover:shadow-lg transition">
          <div className="flex items-center justify-between mb-2">
            <h3 className="text-xl font-semibold text-indigo-700">
              🏢 Tata Elxsi
            </h3>
            <span className="text-sm text-gray-500">
              Mar 2023 – Sep 2023
            </span>
          </div>
          <p className="text-sm text-gray-600 mb-2">
            Backend Developer
          </p>
          <ul className="list-disc list-inside text-gray-700 space-y-1">
            <li>Worked on Spring Boot microservices for vehicle telematics systems.</li>
            <li>Used Kafka, Java 21, and PostgreSQL in production environments.</li>
          </ul>
        </div>

      </div>
    </section>
  );
};

export default Experience;